import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { client } from '../client';
import './index.css';

const Page = () => {
  const { pageId } = useParams();
  const [pageDetails, setPageDetails] = useState([])
  const [userInfo, setUserInfo] = useState([]);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [positionprops, setPositionprops] = useState("block");
  const [accepted, setAccepted] = useState(false);

  const randomizePosition = () => {
    const randomTop = Math.floor(Math.random() * window.innerHeight - 50);
    const randomLeft = Math.floor(Math.random() * window.innerWidth - 100);
    setPosition({
      top: Math.max(0, randomTop),
      left: Math.max(0, randomLeft),
    });
    setPositionprops("absolute")
  };

  const handleAccept = () => {
    setAccepted(true)

    client.patch(pageId).set({
      status: true,
    }).commit();
  }

  useEffect(() => {
      client.fetch(`*[_type == "page" && _id == "${pageId}"]`).then((data) => {
        setPageDetails(data);
      });
  }, [pageId]);

  useEffect(() => {
    client.fetch(`*[_type == "user" && _id == "${pageDetails[0]?.user._ref}"]`).then((data) => {
      setUserInfo(data);
    });
  }, [pageDetails]);

  return (
    <div className="Page">
      {pageDetails[0]?.status ?(
        <div className="not-allowed-page">
          <h1>This page has been already answered.</h1>
        </div>
      ):(
      <>
        <header className="App-header">
        {!accepted?(
          <>
          <h3>{pageDetails[0]?.partnerName}, {pageDetails[0]?.message}, {userInfo[0]?.name}?!</h3>
          <img src="https://media.giphy.com/media/6dmjJwYivqCf0dIOnB/giphy.gif" className="App-logo" alt="logo" />
          <div className="btns">
          <button
            className="proposal-btn"
            onMouseEnter={randomizePosition}
            style={{
              position: `${positionprops}`,
              top: `${position.top}px`,
              left: `${position.left}px`,
            }}
          >
            No
          </button>
          <button
            className="proposal-btn"
            onClick={handleAccept}
          >
            Yes
          </button>
          </div>
          </>
        ):(
          <>
            <h3>Yaaaayyyyyyyyyyyy <br /> Thank you!</h3>
            <img src="https://media.giphy.com/media/fXnKJBaFoTrMv5gIqQ/giphy.gif" className="App-logo" alt="logo" />
          </>
        )}
      </header>
      </>
      )}
    </div>
  )
}

export default Page;
